import type { Achievement } from '@/config/achievementsConfig'

// Everything the celebration layer can present, in one discriminated union.
export type Celebration =
  | { kind: 'achievement'; achievement: Achievement }
  | { kind: 'promotion'; divisionName: string; position: number }
  | { kind: 'title'; divisionName: string; season: number }
  | { kind: 'tournamentWon'; tournamentName: string; prize: number }
  | { kind: 'objectiveMet'; label: string; divisionName: string }
  | { kind: 'objectiveFailed'; label: string }
  | { kind: 'clubChanged'; clubName: string; divisionName: string }

// Achievements and objective verdicts are lower-third banners; the rest
// (promotion/title/tournament/fired/clubChanged) take over the screen.
const BANNER_KINDS = new Set<Celebration['kind']>(['achievement', 'objectiveMet', 'objectiveFailed'])

export function isBigMoment(c: Celebration): boolean {
  return !BANNER_KINDS.has(c.kind)
}
